export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiki"])},
  "shortcut-count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["1 Tastenkürzel"]), _normalize([_interpolate(_named("count")), " Tastenkürzel"])])},
  "command-count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["1 Befehl"]), _normalize([_interpolate(_named("count")), " Befehle"])])},
  "pages": [
    {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tastenbelegung"])},
      "route": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["keyboard"])},
      "icon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mdi-keyboard"])}
    },
    {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Befehle"])},
      "route": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["commands"])},
      "icon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mdi-slash-forward"])}
    },
    {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crime Minigames"])},
      "route": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["crimeminigames"])},
      "icon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mdi-controller"])}
    }
  ],
  "keys": {
    "mouse-right": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechtsklick"])}
  },
  "keyboard": {
    "shortcuts": [
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shift"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mouse-right"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Interaktion mit Spielern, Fahrzeugen, Türen und Mülleimern"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["F12"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Charakter wechseln"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Motor starten"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fahrzeug aus der Ferne auf- und zuschliessen"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["R"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waffe nachladen"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Y"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waffe Magazin entnehmen"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["B"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waffe Feuermodus wechseln"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Z"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hinlegen"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NUMPAD 1-9"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animationen wie Winken, Hände ausstrecken und Hände hoch"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animationsrad öffnen"])}
      },
      {
        "keys": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["X"])}
        ],
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprachlautstärke anpassen"])}
      }
    ]
  },
  "commands": {
    "/l": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Um zurück zur Lobby zu kommen"])},
    "/unverify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entverifiziere deine Teamspeak Identität"])},
    "/log": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erstelle im RP einen Log um andere Spieler zu melden"])},
    "/account-verify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verlinke deinen Website Account mit deinem Minecraft Account"])},
    "/discord-verify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verlinke deinen Discord Account mit deinem Minecraft Account"])},
    "/discord-unlink": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löse die Verbindung von deinem Discord Account auf"])},
    "/id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zeigt dir deine eigene Netzwerk ID"])},
    "/playtime": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Um deine Spielzeit zu prüfen"])},
    "/vote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Damit kannst du für unseren Server voten um eine Belohnung zu bekommen"])},
    "/fix dynamx": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutze diesen Befehl wenn Fahrzeuge oder Objekte nicht korrekt dargestellt werden"])},
    "/fix skin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Behebt visuelle Fehler bei allen Skins"])},
    "/online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zeigt die Anzahl der Spieler auf dem Netzwerk beziehungsweise auf dem aktuellen Server"])}
  },
  "crimeminigames": [
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Labyrinth"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Labyrinth Minigame"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Steuere den blauen Strich mit den Pfeiltasten durch das Labyrinth zum roten Zielfeld. Der Strich bewegt sich kontinuierlich, du musst ihn aktiv durch die freien schwarzen Wege lenken. Berührst du eine graue Wand, verlierst du ein Leben."])}
    },
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lockpick"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dietrich Minigame"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ein roter Marker dreht sich im Uhrzeigersinn um den Ring. Sobald er den blauen Punkt trifft, drück die Leertaste. Danach wechselt die Drehrichtung und der blaue Punkt erscheint an einer neuen Position. Wiederhole das so oft, bis das Schloss aufgeknackt ist. Zu langsam oder verpasst – und du verlierst einen Versuch. "])}
    },
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Propangas"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Propangas Minigame "])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Halte die Leertaste/Linke Maustaste gedrückt, um Gas in den Automaten zu pumpen, ein blauer Balken steigt dabei von unten nach oben. Lass die Taste los, sobald der Balken im grünen Bereich ist. Steigt er in den roten Bereich, explodiert der Geldautomat und die Mission schlägt fehl."])}
    },
    {
      "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["BruteForce"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brute Force Minigame"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zeichen fallen von oben nach unten durch das Raster. Sobald ein rotes Zeichen die mittlere rote Linie erreicht, drück die Leertaste/Linke Maustaste. Bei einem Treffer springt der blaue Balken eine Spalte nach rechts weiter. Schaffst du alle Spalten, ist der Hack erfolgreich.Verpasst du zu viele rote Zeichen, schlägt der Einbruch fehl."])}
    }
  ]
}